import React from "react";
import { MessageCircle } from "lucide-react";
import { useLang } from "@/context/Lang";
import { CONTACT, IMAGES } from "@/data";
import { Reveal } from "@/components/site/Reveal";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export default function MidCTA() {
  const { t } = useLang();
  return (
    <section className="relative bg-navy grain overflow-hidden" data-testid="mid-cta">
      <div className="absolute inset-0">
        <img src={IMAGES.ctaBg} alt="Freshly remodeled home ready for a free quote from Seven Home Services" className="w-full h-full object-cover opacity-20" />
        <div className="absolute inset-0 bg-gradient-to-r from-navy via-navy/90 to-navy/60" />
      </div>
      <div className="relative z-10 max-w-5xl mx-auto px-4 md:px-8 py-24 md:py-32 text-center">
        <Reveal>
          <h2 className="font-display font-black text-white text-4xl md:text-6xl lg:text-7xl leading-[0.9] tracking-tighter uppercase">
            {t.midcta.title}
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 text-white/70 text-lg max-w-2xl mx-auto">{t.midcta.sub}</p>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => scrollTo("quote")}
              data-testid="midcta-quote"
              className="bg-orange hover:bg-[#1550C0] text-white font-bold text-base px-8 py-4 rounded-full transition-colors"
            >
              {t.midcta.cta1}
            </button>
            <a
              href={CONTACT.whatsapp}
              target="_blank"
              rel="noreferrer"
              data-testid="midcta-whatsapp"
              className="inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#20bd5a] text-white font-bold text-base px-8 py-4 rounded-full transition-colors"
            >
              <MessageCircle size={18} /> {t.midcta.cta2}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
